var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"botao-pdf",attrs:{"href":_vm.url,"target":"_blank","title":"Baixar PDF"},on:{"click":function($event){return _vm.registra_GA4()}}},[_c('img',{attrs:{"src":require("../assets/images/pdf-icon.png"),"alt":"Baixar arquivo em formato PDF"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }